import { Skeleton } from '@mui/material';
import React from 'react';

interface IThumbnailsSkeletonProps {
    getMany?: boolean;
}

const ThumbnailsSkeleton = (props: IThumbnailsSkeletonProps) => {
    const { getMany } = props;

    return getMany ? (
        <React.Fragment>
            <Skeleton
                variant="rectangular"
                animation="wave"
                height={91}
                width={59}
                style={{ marginBottom: '4px' }}
            />
            <Skeleton
                variant="rectangular"
                animation="wave"
                height={91}
                width={59}
                style={{ marginBottom: '4px' }}
            />
            <Skeleton
                variant="rectangular"
                animation="wave"
                height={91}
                width={59}
                style={{ marginBottom: '4px' }}
            />
        </React.Fragment>
    ) : (
        <Skeleton
            variant="rectangular"
            animation="wave"
            height={91}
            width={59}
            style={{ marginBottom: '4px' }}
        />
    );
};

export default ThumbnailsSkeleton;
